// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__leEAg","colMin":"styles_colMin__35Iob"};